function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23037",
    transform: "translate(-450.51 -191.727)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 679",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(450.51 191.727)",
    style: {
      fill: "#ffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16444",
    d: "M20.915 3.016V22.2a.757.757 0 0 1-1.184.625L17.212 21.1l-2.381 1.71a.755.755 0 0 1-.94-.045l-1.809-1.582-1.809 1.582a.755.755 0 0 1-.94.045l-2.38-1.71-2.519 1.72a.757.757 0 0 1-1.184-.62V3.016A1.766 1.766 0 0 1 5.016 1.25h14.132a1.766 1.766 0 0 1 1.767 1.766zm-12.87 7.823h8.075a.757.757 0 1 0 0-1.514H8.045a.757.757 0 0 0 0 1.514zm0-4.038h8.075a.757.757 0 1 0 0-1.514H8.045a.757.757 0 0 0 0 1.514zm0 8.075h4.038a.757.757 0 0 0 0-1.514H8.045a.757.757 0 0 0 0 1.514z",
    transform: "translate(463.693 204.626)",
    style: {
      fill: "#fbe5e5",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.06ca371ddccd7b11d534ef9f8f4254b6.svg";
export { ForwardRef as ReactComponent };